import { render, staticRenderFns } from "./ScreenOffer.vue?vue&type=template&id=a5b812e4"
import script from "./ScreenOffer.vue?vue&type=script&lang=js"
export * from "./ScreenOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports